import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Navigation, Instagram, ArrowUpRight, Clock } from "lucide-react";
import { CONTACT } from "../../mock";
import { WhatsApp } from "../Social";
import { useToast } from "../../hooks/use-toast";
import { KineticText, Reveal, Magnetic } from "../../lib/motion";

export default function ReserveNight() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [email, setEmail] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!email) { toast({ title: "Enter your email", description: "We'll reach out with availability for your stay." }); return; }
    toast({ title: "You're on the list!", description: "We'll reach out with dates & pricing for your paradise stay." });
    setEmail("");
  };

  return (
    <section className="relative py-28 px-6">
      <div className="max-w-[1100px] mx-auto w-full text-center">
        <Reveal>
          <span className="font-body text-xs tracking-[0.35em] uppercase text-white/60">Stay The Night</span>
        </Reveal>
        <h2 className="font-display font-extrabold text-white leading-[0.9] text-6xl md:text-[7rem] mt-4">
          <KineticText text="Your paradise" />
          <span className="block font-serif-i italic font-normal text-[var(--amber-light)]"><KineticText text="awaits" delay={0.15} /></span>
        </h2>

        <Reveal delay={0.2}>
          <form onSubmit={submit} className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 max-w-xl mx-auto">
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email for dates & pricing"
              className="w-full flex-1 rounded-full bg-white/10 border border-white/25 text-white placeholder:text-white/50 px-6 py-4 focus:outline-none focus:ring-2 focus:ring-[var(--amber)]/50"
            />
            <Magnetic strength={0.4}>
              <button type="submit" className="btn-shine sunset-fill text-white font-body font-bold px-8 py-4 rounded-full whitespace-nowrap">Get Availability</button>
            </Magnetic>
          </form>
        </Reveal>

        <Reveal delay={0.3}>
          <button onClick={() => navigate("/booking")} className="group inline-flex items-center gap-2 mt-6 text-white/80 hover:text-white font-body font-semibold">
            or go straight to booking <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </button>
        </Reveal>

        {/* Contact quick facts */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-20 text-left">
          {[
            { icon: Navigation, label: "Get Directions", value: "Open in Apple Maps", href: CONTACT.maps.apple },
            { icon: WhatsApp, label: "WhatsApp", value: "Message us instantly", href: CONTACT.whatsapp },
            { icon: Instagram, label: "Instagram", value: "@thejacksonhousergv", href: CONTACT.socials.instagram },
          ].map((c) => (
            <Reveal key={c.label}>
              <a href={c.href} target="_blank" rel="noreferrer" data-cursor="hover" className="flex items-start gap-3 rounded-2xl bg-white/5 border border-white/10 p-5 hover:bg-white/10 transition-colors">
                <span className="w-10 h-10 rounded-full sunset-fill grid place-items-center text-white shrink-0"><c.icon size={17} /></span>
                <div>
                  <p className="font-body uppercase tracking-widest text-[10px] text-white/40">{c.label}</p>
                  <p className="font-body font-semibold text-white break-all">{c.value}</p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <p className="inline-flex items-center gap-2 mt-8 text-white/50 text-sm flex-wrap justify-center"><Clock size={15} className="text-[var(--amber)]" /> Check-in {CONTACT.checkIn} &middot; Check-out {CONTACT.checkOut} &middot; Free private parking &middot; <a href={CONTACT.maps.google} target="_blank" rel="noreferrer" className="underline hover:text-white">Google Maps</a></p>
        </Reveal>
      </div>
    </section>
  );
}
